import { assertNever } from '../../../../../../replicant/utils';
import { Vector2 } from '../../../odie';
import { Particle } from '../Particle';
import { IBehavior } from './IBehavior';

export type EmiterShapeBehaviorOptions = {
  type: 'emiterShape';
} & (
  | {
      shape: 'circle';
      radius: number;
    }
  | {
      shape: 'rectangle';
      width: number;
      height: number;
    }
);

export class EmiterShapeBehavior implements IBehavior {
  private _particle: Particle;
  private _options: EmiterShapeBehaviorOptions;

  constructor(particle: Particle, options: EmiterShapeBehaviorOptions) {
    this._particle = particle;
    this._options = options;
  }

  public start() {
    let position = new Vector2();
    switch (this._options.shape) {
      case 'circle':
        position = this.randomPointInCircle();
        break;
      case 'rectangle':
        position = this.randomPointInRectangle();
        break;
      default:
        assertNever(this._options);
    }

    this._particle.x = position.x;
    this._particle.y = position.y;
  }

  private randomPointInCircle(): Vector2 {
    if (this._options.shape !== 'circle') return new Vector2();

    const radius = this._options.radius;
    const angle = Math.random() * Math.PI * 2;
    return new Vector2(Math.cos(angle) * radius, Math.sin(angle) * radius);
  }

  private randomPointInRectangle(): Vector2 {
    if (this._options.shape !== 'rectangle') return new Vector2();

    const width = this._options.width;
    const height = this._options.height;
    return new Vector2(
      Math.random() * width - width / 2,
      Math.random() * height - height / 2,
    );
  }
}
